import { render, staticRenderFns } from "./ProjectCopy.vue?vue&type=template&id=8fb7196a"
import script from "./ProjectCopy.vue?vue&type=script&lang=js"
export * from "./ProjectCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports